export const SET_DATA = 'SET_DATA'

export const setData = (data) => ({ type: SET_DATA, value: data });


